const WeightsBreakdown = () => {
  return (
    <>
      <div className="cards weightsBreakdown_card">
        <h2>Weights Breakdown</h2>

        <ul>
          <li className="active">
            <img src="/static/images/airplane_icon.svg" alt="icon" />
            <p>Airline</p>
          </li>
          <li>
            <img src="/static/images/bus_icon.svg" alt="icon" />
            <p>Train</p>
          </li>
          <li>
            <img src="/static/images/ship2_icon.svg" alt="icon" />
            <p>Sea</p>
          </li>
          <li>
            <img src="/static/images/people_icon.svg" alt="icon" />
            <p>Private</p>
          </li>
          <li>
            <img src="/static/images/profile2_icon.svg" alt="icon" />
            <p>Public</p>
          </li>
        </ul>

        <figure>
          <img src="/static/images/breakdown_graph.png" alt="" />
        </figure>
      </div>
    </>
  );
};

export default WeightsBreakdown;
